import modifiedFetch from "../../../setup/axios/ModifiedFetch";
import {
  CreateTrustIdApplicationPayload,
  TrustIdApplication,
} from "../models/right-to-work-model";

const IDENTITY_URL = process.env.REACT_APP_CAPSIL_IDENTITY_URL;
const API_KEY = process.env.REACT_APP_X_API_KEY;

export const CREATE_TRUST_ID_APPLICATION_URL = `${IDENTITY_URL}/trustid/applications`;

export function createTrustIdApplication(
  payload: CreateTrustIdApplicationPayload,
): Promise<{ data: TrustIdApplication }> {
  return modifiedFetch({
    url: CREATE_TRUST_ID_APPLICATION_URL,
    method: "POST",
    data: payload,
    xApiKey: API_KEY,
  });
}

export function getTrustIdApplication(
  id: string,
): Promise<{ data: TrustIdApplication }> {
  return modifiedFetch({
    url: `${IDENTITY_URL}/trustid/applications/${id}`,
    method: "GET",
    xApiKey: API_KEY,
  });
}

export function getLatestTrustIdApplicationForAdi(
  adiNumber: string,
): Promise<{ data: TrustIdApplication | null }> {
  return modifiedFetch({
    url: `${IDENTITY_URL}/trustid/applications/by-adi/${adiNumber}`,
    method: "GET",
    xApiKey: API_KEY,
  });
}
